import * as Yup from 'yup';

export default Yup.object().shape({
    discountId: Yup.number().nullable(),
});